var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletpoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.6971V10.5271H1.00036V11.6963L0 11.6971ZM0 8.18782V7.01776H1.00036V8.18782H0ZM0 4.67851V3.50931H1.00036V4.67851H0ZM0 1.1692V0H1.00036V1.1692H0Z",
    fill: "#3078CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72754 11.6971V10.5271H13.7276V11.6963L1.72754 11.6971ZM1.72754 8.18782V7.01776H13.7276V8.18782H1.72754ZM1.72754 4.67851V3.50931H13.7276V4.67851H1.72754ZM1.72754 1.1692V0H13.7276V1.1692H1.72754Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletpoints);
export default __webpack_public_path__ + "static/media/bulletpoints.8b750e59a0b74281e3721927718a64f7.svg";
export { ForwardRef as ReactComponent };